/* eslint-disable @typescript-eslint/no-explicit-any */
export const sortByKey = (array: Array<any>, key: string) => {
  const newArray = [...array]
  return newArray.sort((a, b) => {
    const x = a[key] ?? 999
    const y = b[key] ?? 999

     
    return x < y ? -1 : x > y ? 1 : 0
  })
}
